module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-44.b152173b.png";